import { render, staticRenderFns } from "./HelpDetailsComponent.vue?vue&type=template&id=349247dd&scoped=true&"
import script from "./HelpDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./HelpDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./HelpDetailsComponent.vue?vue&type=style&index=0&id=349247dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349247dd",
  null
  
)

export default component.exports